// Utils
import createDeepEqualSelector from '../../utils/reselect/createDeepEqualSelector';

// Selectors
import { makeSelectGroupPeopleIds } from '../groupPeople/selectors';

// Types
import type { Timesheet } from '../timesheets/types';

type State = {
    timesheet: ?Timesheet
};

const selectTimesheet = (state: State) => state.timesheet;

const makeSelectTimesheetValue = (field: string) =>
    createDeepEqualSelector(
        selectTimesheet,
        timesheetState => timesheetState && timesheetState[field]
    );

const selectState = (state: *) => state;

const selectTimesheetDefaultPersonIds = createDeepEqualSelector(
    [selectState, makeSelectTimesheetValue('groupId')],
    (state, timesheetGroupIdState) =>
        makeSelectGroupPeopleIds()(state, { groupId: timesheetGroupIdState })
);

export { makeSelectTimesheetValue, selectTimesheetDefaultPersonIds };
